module.exports = __webpack_public_path__ + "img/components.12abe8d5.svg";